<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="'Move'"
    :max-width="800"
  >
    <template slot="header">
      <div
        style="width: 100%;"
        class="d-flex justify-space-between align-center"
      >
        <span
          v-if="item"
          class="f6 fw600"
        >Glass Item# - {{ item.po_number }}-{{ item.item_index }}</span>
        <div
          class="d-flex"
          style="gap: 6px;"
        >
          <v-chip
            :color="item && item.class ? item.class.color : 'black'"
            text-color="white"
          >
            {{ item && item.class ? item.class.name : '' }}
          </v-chip>
          <v-chip
            :color="item && item.status ? item.status.color : 'black'"
            text-color="white"
          >
            {{ item && item.status ? item.status.name : '' }}
          </v-chip>
        </div>
      </div>
    </template>
    <template slot="body">
      <div
        v-if="item"
        class="d-flex flex-column ga-6 pt-2"
      >
        <div class="d-flex flex-column ga-1">
          <span class="title-span">{{ jobLabel }}</span>
          <div class="desc-div">
            <span
              class="desc-span"
              style="font-weight: bold;"
            >{{ item.job_code ? `${item.job_code}` : '' }}</span> - <span class="desc-span">{{ item.job_name ? item.job_name : item.job_name }}</span> <span
              class="desc-span"
              style="color: #1976D2;"
            >{{ item.job_reference ? `; ${item.job_reference}` : '' }}</span>
          </div>
        </div>

        <div class="d-flex ga-3 align-center">
          <div class="outer-div">
            <span class="title-span">PO#</span>
            <div class="desc-div">
              <span class="desc-span">{{ item.po_number }}</span>
            </div>
          </div>

          <div class="outer-div">
            <span class="title-span">Batch</span>
            <div class="desc-div">
              <span class="desc-span">{{ item.batch_number }}</span>
            </div>
          </div>

          <div class="outer-div">
            <span class="title-span">Tag#</span>
            <div class="desc-div">
              <span class="desc-span">{{ item.tag_number }}</span>
            </div>
          </div>
        </div>

        <span
          class="f8 fw600"
          style="color: #000"
        >Glass Specifications </span>

        <div class="d-flex ga-3 align-center">
          <div class="outer-div">
            <span class="title-span">Glass Code</span>
            <div class="desc-div">
              <span class="desc-span">{{ item.g_code }}</span>
            </div>
          </div>

          <div class="outer-div">
            <span class="title-span">Glass Thickness</span>
            <div class="desc-div">
              <span class="desc-span">{{ item.glass_thickness }}</span>
            </div>
          </div>
        </div>

        <span
          class="f8 fw600"
          style="color: #000"
        >Dimentions </span>

        <div class="d-flex ga-3 align-center">
          <div class="outer-div">
            <span class="title-span">Width</span>
            <div class="desc-div">
              <span class="desc-span">{{ convertToFraction(item.width) }}</span>
            </div>
          </div>

          <div class="outer-div">
            <span class="title-span">Height</span>
            <div class="desc-div">
              <span class="desc-span">{{ convertToFraction(item.height) }}</span>
            </div>
          </div>

          <div class="outer-div">
            <span class="title-span">Quantity</span>
            <div class="desc-div">
              <span class="desc-span">{{ item.quantity }}</span>
            </div>
          </div>
        </div>

        <v-divider style="border-bottom: 1px solid #BDBDBD;" />

        <span
          class="f8 fw600"
          style="color: #000"
        >Status Managemenet </span>

        <div class="outer-div">
          <span class="title-span">Move to Status</span>
          <v-select
            v-model="selectedStatusId"
            :items="statuses"
            item-text="name"
            item-value="id"
            hide-details="true"
            outlined
            clearable
            :rules="[(v) => !!v || 'Move to Status is required']"
            placeholder="Select Status"
          >
            <template #item="{ item }">
              <v-chip
                class="mt-1 mb-1"
                small
                text-color="white"
                style="cursor: pointer;"
                :color="item ? item.color : 'white'"
              >
                {{ item ? item.name : '' }}
              </v-chip>
            </template>
            <!-- eslint-disable-next-line vue/no-template-shadow -->
            <template #selection="{ item }">
              <v-chip
                class="mt-1 mb-1"
                small
                text-color="white"
                style="cursor: pointer;"
                :color="item ? item.color : 'white'"
              >
                {{ item ? item.name : '' }}
              </v-chip>
            </template>
          </v-select>
        </div>
        <div
          v-if="selectedStatusId === statusIdRejected"
          class="pt-5"
        >
          <span class="title-span">Select Rejected Glass</span>
          <div v-if="item.glass && item.glass.glass_code_type_id == glassCodeTypeIdSealedUnit">
            <v-checkbox
              v-if="!checkHasRejection(item, rejection_type_id_exterior)"
              v-model="isExteriorGlassRejected"
              label="Exterior Glass Rejected"
              :true-value="1"
              :false-value="0"
              hide-details
            >
              <template slot="label">
                <span class="desc-span">Exterior Glass Rejected</span>
              </template>
            </v-checkbox>
            <v-checkbox
              v-if="item.glass.center_glass && !checkHasRejection(item, rejection_type_id_central)"
              v-model="isCentralGlassRejected"
              label="Central Glass Rejected"
              :true-value="1"
              :false-value="0"
              hide-details
            >
              <template slot="label">
                <span class="desc-span">Central Glass Rejected</span>
              </template>
            </v-checkbox>
            <v-checkbox
              v-if="!checkHasRejection(item, rejection_type_id_interior)"
              v-model="isInteriorGlassRejected"
              label="Interior Glass Rejected"
              :true-value="1"
              :false-value="0"
              hide-details
            >
              <template slot="label">
                <span class="desc-span">Interior Glass Rejected</span>
              </template>
            </v-checkbox>
          </div>
          <div v-else>
            <v-checkbox
              v-if="!checkHasRejection(item, rejection_type_id_single)"
              v-model="isSingleGlassRejected"
              label="Single Glass Rejected"
              :true-value="1"
              :false-value="0"
              hide-details
            >
              <template slot="label">
                <span class="desc-span">{{ item.glass && item.glass.glass_code_type_id == glassCodeTypeIdSpandrel ? 'Spandrel' : 'Single' }} Glass Rejected</span>
              </template>
            </v-checkbox>
          </div>
        </div>

        <div
          v-if="selectedStatusId === statusIdTempering"
          class="pt-5"
        >
          <span class="title-span">Select Qualified Glass</span>
          <div v-if="item.glass && item.glass.glass_code_type_id == glassCodeTypeIdSealedUnit">
            <v-checkbox
              v-if="isHeatTreated(item.glass.ext_heat_treatment)"
              v-model="isExteriorGlassQualified"
              label="Exterior Glass Qualified"
              :true-value="1"
              :false-value="0"
              hide-details
              :disabled="!checkHasRejection(item, rejection_type_id_exterior,1, false)"
            >
              <template slot="label">
                <span class="desc-span">Exterior Glass Qualified</span>
              </template>
            </v-checkbox>
            <v-checkbox
              v-if="isHeatTreated(item.glass.cen_heat_treatment)"
              v-model="isCentralGlassQualified"
              label="Central Glass Qualified"
              :true-value="1"
              :false-value="0"
              hide-details
              :disabled="!checkHasRejection(item, rejection_type_id_central, 1, false)"
            >
              <template slot="label">
                <span class="desc-span">Central Glass Qualified</span>
              </template>
            </v-checkbox>
            <v-checkbox
              v-if="isHeatTreated(item.glass.int_heat_treatment)"
              v-model="isInteriorGlassQualified"
              label="Interior Glass Qualified"
              :true-value="1"
              :false-value="0"
              hide-details
              :disabled="!checkHasRejection(item, rejection_type_id_interior, 1, false)"
            >
              <template slot="label">
                <span class="desc-span">Interior Glass Qualified</span>
              </template>
            </v-checkbox>
          </div>
          <div v-else>
            <v-checkbox
              v-if="isHeatTreated(item.glass.sgl_heat_treatment)"
              v-model="isSingleGlassQualified"
              label="Single Glass Qualified"
              :true-value="1"
              :false-value="0"
              hide-details
              :disabled="!checkHasRejection(item, rejection_type_id_single, 1, false)"
            >
              <template slot="label">
                <span class="desc-span">Single Glass Qualified</span>
              </template>
            </v-checkbox>
          </div>
        </div>

        <div
          v-if="selectedStatusId === statusIdCutting"
          class="pt-5"
        >
          <span class="title-span">Select Qualified Glass</span>
          <div v-if="item.glass && item.glass.glass_code_type_id == glassCodeTypeIdSealedUnit">
            <v-checkbox
              v-if="!isHeatTreated(item.glass.ext_heat_treatment)"
              v-model="isExteriorGlassQualified"
              label="Exterior Glass Qualified"
              :true-value="1"
              :false-value="0"
              hide-details
              :disabled="!checkHasRejection(item, rejection_type_id_exterior,0, false)"
            >
              <template slot="label">
                <span class="desc-span">Exterior Glass Qualified</span>
              </template>
            </v-checkbox>
            <v-checkbox
              v-if="item.glass.center_glass && !isHeatTreated(item.glass.cen_heat_treatment)"
              v-model="isCentralGlassQualified"
              label="Central Glass Qualified"
              :true-value="1"
              :false-value="0"
              hide-details
              :disabled="!checkHasRejection(item, rejection_type_id_central,0, false)"
            >
              <template slot="label">
                <span class="desc-span">Central Glass Qualified</span>
              </template>
            </v-checkbox>
            <v-checkbox
              v-if="!isHeatTreated(item.glass.int_heat_treatment)"
              v-model="isInteriorGlassQualified"
              label="Interior Glass Qualified"
              :true-value="1"
              :false-value="0"
              hide-details
              :disabled="!checkHasRejection(item, rejection_type_id_interior,0, false)"
            >
              <template slot="label">
                <span class="desc-span">Interior Glass Qualified</span>
              </template>
            </v-checkbox>
          </div>
          <div v-else>
            <v-checkbox
              v-if="!isHeatTreated(item.glass.sgl_heat_treatment)"
              v-model="isSingleGlassQualified"
              label="Single Glass Qualified"
              :true-value="1"
              :false-value="0"
              hide-details
              :disabled="!checkHasRejection(item, rejection_type_id_single, 0, false)"
            >
              <template slot="label">
                <span class="desc-span">Single Glass Qualified</span>
              </template>
            </v-checkbox>
          </div>
        </div>
      </div>
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import fileParserApi from '../../../api/FileParserApi';

export default {
  components: {

  },
  props: {

  },
  data: () => ({
    item: null,
    statusIdNew: 1,
    statusIdShipped: 6,
    statusIdReceived: 7,
    statusIdCutting: 10,
    statusIdTempering: 11,
    statusIdRejected: 16,
    statusIdIssued: 17,
    statusIdShippedToSite: 12,
    statusIdReceivedOnSite: 13,
    selectedStatusId: null,
    glassCodeTypeIdSpandrel: 1,
    glassCodeTypeIdSealedUnit: 2,
    glassCodeTypeIdSingleGlass: 3,
    isExteriorGlassRejected: 0,
    isCentralGlassRejected: 0,
    isInteriorGlassRejected: 0,
    isSingleGlassRejected: 0,
    isExteriorGlassQualified: 0,
    isCentralGlassQualified: 0,
    isInteriorGlassQualified: 0,
    isSingleGlassQualified: 0,
    rejection_type_id_single: 1,
    rejection_type_id_exterior: 2,
    rejection_type_id_central: 3,
    rejection_type_id_interior: 4,
  }),
  computed: {
    jobLabel() {
      return this.$store.getters['businessRulesGetBoolean']('Jobs Rename to Release')
        ? 'Release'
        : 'Job'; 
    },
    ...mapState({

    }),
    ...mapGetters([

    ]),
  },
  watch: {

  },
  created() {
    this.getStatuses();
  },
  methods: {

    async get(qrCode) {
      this.item = null;
      this.$bus.$emit('loading');
      const poNumberAndItemIndexMap = this.extractPoNumberAndItemIndex(qrCode);
      if (!poNumberAndItemIndexMap || !poNumberAndItemIndexMap.po_number || !poNumberAndItemIndexMap.item_index) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError', 'QR code not valid');
        this.$refs.dialogBox.close();
        return;
      }
      const submitModel = {
        filters: {
          po_number: poNumberAndItemIndexMap.po_number,
          item_index: poNumberAndItemIndexMap.item_index,
          is_pack_slip_null: 1,
          is_batch: 1,
        },
      };
      const res = await this.$api.glass.readGlass(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || !res.data || res.data.length === 0 || res.data[0].batch_id === null) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError', 'Glass item not found');
        this.$refs.dialogBox.close();
        return;
      }
      const firstIndex = 0;
      if (res.data[firstIndex].status_id === this.statusIdShipped || res.data[firstIndex].status_id === this.statusIdReceived || res.data[firstIndex].status_id === this.statusIdShippedToSite || res.data[firstIndex].status_id === this.statusIdReceivedOnSite) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError', 'Glass item has already been shipped or received');
        this.$refs.dialogBox.close();
        return;
      }
      this.item = res.data[firstIndex];

      if (this.item && this.item.rejections && this.item.rejections.length > 0) {
        this.isExteriorGlassQualified = this.item.rejections.some((x) => x.type_id === this.rejection_type_id_exterior && x.is_qualified === 1) ? 1 : 0;
        this.isCentralGlassQualified = this.item.rejections.some((x) => x.type_id === this.rejection_type_id_central && x.is_qualified === 1) ? 1 : 0;
        this.isInteriorGlassQualified = this.item.rejections.some((x) => x.type_id === this.rejection_type_id_interior && x.is_qualified === 1) ? 1 : 0;
        this.isSingleGlassQualified = this.item.rejections.some((x) => x.type_id === this.rejection_type_id_single && x.is_qualified === 1) ? 1 : 0;
      } else {
        this.isExteriorGlassQualified = 0;
        this.isCentralGlassQualified = 0;
        this.isInteriorGlassQualified = 0;
        this.isSingleGlassQualified = 0;
      }
      this.$bus.$emit('loading');
    },

    async getStatuses() {
      const res = await this.$api.glassPoStatus.get();
      this.statuses = res.filter((x) => x.id === this.statusIdIssued || x.id === this.statusIdCutting || x.id === this.statusIdTempering || x.id === this.statusIdRejected);
    },

    async submit() {
      const submitModel = {
        po_number: this.item.po_number,
        item_index: this.item.item_index,
        status_id: this.selectedStatusId,
        is_switch_status: true,
      };

      const { glass } = this.item;
      const isSealedUnit = glass.glass_code_type_id === this.glassCodeTypeIdSealedUnit;

      if (!this.checkARequiredSelected()) {
        this.$bus.$emit('showError', 'Please select at least one glass to be qualified or rejected');
        return false;
      }

      // Disable switch status if any heat-treated glass is unqualified (Tempering)
      if (this.selectedStatusId === this.statusIdTempering) {
        if (isSealedUnit) {
          if (this.isHeatTreated(glass.ext_heat_treatment) && !this.isExteriorGlassQualified) submitModel.is_switch_status = false;
          if (this.isHeatTreated(glass.cen_heat_treatment) && !this.isCentralGlassQualified) submitModel.is_switch_status = false;
          if (this.isHeatTreated(glass.int_heat_treatment) && !this.isInteriorGlassQualified) submitModel.is_switch_status = false;
        } else if (this.isHeatTreated(glass.sgl_heat_treatment) && !this.isSingleGlassQualified) {
          submitModel.is_switch_status = false;
        }
      }

      // Disable switch status for Cutting if non-heat-treated glass is unqualified
      if (this.selectedStatusId === this.statusIdCutting) {
        if (isSealedUnit) {
          if (!this.isHeatTreated(glass.ext_heat_treatment) && !this.isExteriorGlassQualified) submitModel.is_switch_status = false;
          if (glass.center_glass && !this.isHeatTreated(glass.cen_heat_treatment) && !this.isCentralGlassQualified) submitModel.is_switch_status = false;
          if (!this.isHeatTreated(glass.int_heat_treatment) && !this.isInteriorGlassQualified) submitModel.is_switch_status = false;
        } else if (!this.isHeatTreated(glass.sgl_heat_treatment) && !this.isSingleGlassQualified) {
          submitModel.is_switch_status = false;
        }
      }

      // Set rejected flags if status is Rejected
      if (this.selectedStatusId === this.statusIdRejected) {
        if (isSealedUnit) {
          if (this.isExteriorGlassRejected) submitModel.is_exterior_glass_rejected = 1;
          if (this.isCentralGlassRejected) submitModel.is_central_glass_rejected = 1;
          if (this.isInteriorGlassRejected) submitModel.is_interior_glass_rejected = 1;
        } else if (this.isSingleGlassRejected) {
          submitModel.is_single_glass_rejected = 1;
        }
      }

      // Set rejected flags to 0 if glass is qualified in Tempering/Cutting
      const shouldClearReject = [this.statusIdTempering, this.statusIdCutting].includes(this.selectedStatusId);
      if (shouldClearReject) {
        const clearRejectIfQualified = (treatment, qualified, key) => {
          if (
            (this.selectedStatusId === this.statusIdTempering && this.isHeatTreated(treatment) && qualified) || (this.selectedStatusId === this.statusIdCutting && !this.isHeatTreated(treatment) && qualified)
          ) {
            submitModel[key] = 0;
          }
        };

        if (isSealedUnit) {
          clearRejectIfQualified(glass.ext_heat_treatment, this.isExteriorGlassQualified, 'is_exterior_glass_rejected');
          clearRejectIfQualified(glass.cen_heat_treatment, this.isCentralGlassQualified, 'is_central_glass_rejected');
          clearRejectIfQualified(glass.int_heat_treatment, this.isInteriorGlassQualified, 'is_interior_glass_rejected');
        } else {
          clearRejectIfQualified(glass.sgl_heat_treatment, this.isSingleGlassQualified, 'is_single_glass_rejected');
        }
      }

      // Submit
      const res = await this.$api.glassPurchaseOrderItem.store(submitModel, 'move');
      if (!res) {
        this.$bus.$emit('showError');
        return false;
      }

      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return res;
    },

    open(qrCode) {
      if (!qrCode) return;
      this.$refs.dialogBox.open();
      this.get(qrCode);
      this.isExteriorGlassRejected = 0;
      this.isCentralGlassRejected = 0;
      this.isInteriorGlassRejected = 0;
      this.isSingleGlassRejected = 0;
    },

    extractPoNumberAndItemIndex(glassItemQr) {
      if (!glassItemQr) return false;
      const [poNumber, itemIndex] = glassItemQr.split('-');
      const poNumberAndItemIndexMap = {
        po_number: parseInt(poNumber, 10),
        item_index: parseInt(itemIndex, 10),
      };
      if (!poNumber || !itemIndex) return false;
      return poNumberAndItemIndexMap;
    },

    convertToFraction(decimal) {
      const fractions = {
        0.0625: '1/16',
        0.125: '1/8',
        0.1875: '3/16',
        0.25: '1/4',
        0.3125: '5/16',
        0.375: '3/8',
        0.4375: '7/16',
        0.5: '1/2',
        0.5625: '9/16',
        0.625: '5/8',
        0.6875: '11/16',
        0.75: '3/4',
        0.8125: '13/16',
        0.875: '7/8',
        0.9375: '15/16',
      };

      // If the decimal is an exact match to any fraction, return the fraction directly
      if (decimal in fractions) {
        return fractions[decimal];
      }

      const wholeNumber = Math.floor(decimal);
      // eslint-disable-next-line no-param-reassign
      decimal -= wholeNumber; // Remove the whole number part

      let closestFraction = Object.keys(fractions)[0];

      // eslint-disable-next-line no-restricted-syntax
      for (const fraction of Object.keys(fractions)) {
        if (Math.abs(decimal - fraction) < Math.abs(decimal - closestFraction)) {
          closestFraction = fraction;
        }
      }

      if (wholeNumber > 0) {
        return `${wholeNumber} - ${fractions[closestFraction]}"`;
      }
      return fractions[closestFraction];
    },

    checkHasRejection(item, rejectionTypeId, isHeatTreated = null, isCheckEmpty = true) {
      const rejections = isHeatTreated != null ? item.rejections.filter((x) => x.is_heat_treated === isHeatTreated) : item.rejections;

      if (rejections && rejections.length > 0) {
        if (rejections.some((x) => x.type_id === rejectionTypeId && x.is_qualified === 1)) return false;
        if (rejections.some((x) => x.type_id === rejectionTypeId && x.is_qualified === 0)) return true;
      }

      if (isCheckEmpty) return false;
      return true;
    },

    isHeatTreated(treatment) {
      return ['HST', 'TMP', 'TSH', 'HSO'].includes(treatment);
    },

    checkARequiredSelected() {
      if (this.selectedStatusId === this.statusIdIssued) return true;

      const { glass } = this.item;
      const isSealedUnit = glass.glass_code_type_id === this.glassCodeTypeIdSealedUnit;
      if (this.selectedStatusId === this.statusIdTempering) {
        if (isSealedUnit) {
          if ((this.isHeatTreated(glass.ext_heat_treatment) && !this.isExteriorGlassQualified) && (this.isHeatTreated(glass.cen_heat_treatment) && !this.isCentralGlassQualified) && (this.isHeatTreated(glass.int_heat_treatment) && !this.isInteriorGlassQualified)) return false;
        } else if (this.isHeatTreated(glass.sgl_heat_treatment) && !this.isSingleGlassQualified) {
          return false;
        }
      }

      if (this.selectedStatusId === this.statusIdCutting) {
        if (isSealedUnit) {
          if ((!this.isHeatTreated(glass.ext_heat_treatment) && !this.isExteriorGlassQualified) && (glass.center_glass && !this.isHeatTreated(glass.cen_heat_treatment) && !this.isCentralGlassQualified) && (!this.isHeatTreated(glass.int_heat_treatment) && !this.isInteriorGlassQualified)) return false;
        } else if (!this.isHeatTreated(glass.sgl_heat_treatment) && !this.isSingleGlassQualified) {
          return false;
        }
      }

      if (this.selectedStatusId === this.statusIdRejected) {
        if (isSealedUnit) {
          if (!this.isExteriorGlassRejected && !this.isCentralGlassRejected && !this.isInteriorGlassRejected) return false;
        } else if (!this.isSingleGlassRejected) {
          return false;
        }
      }

      return true;
    },
  },
};
</script>

<style scoped>

.outer-div{
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;

}
.title-span
{
  color: #000;
  font-size: 18px;
  font-weight: 500;
}

.desc-div
{
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 8px;
  padding-right: 8px;
  border: 1px solid #BDBDBD;
  border-radius: 6px;
  background-color: #F9F9FA;
}

.desc-span
{
  color: #000;
  font-size: 20px;
}
</style>
